module.exports = __webpack_public_path__ + "static/media/459A9496 copy.f7b05d25.jpg";